"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentModel = exports.EnvironmentAPIKeyModel = void 0;
var EnvironmentAPIKeyModel = /** @class */ (function () {
    function EnvironmentAPIKeyModel(id, key, createdAt, name, clientApiKey, expiresAt) {
        this.active = true;
        this.id = id;
        this.key = key;
        this.createdAt = createdAt;
        this.name = name;
        this.clientApiKey = clientApiKey;
        this.expiresAt = expiresAt;
    }
    EnvironmentAPIKeyModel.prototype.isValid = function () {
        return !!this.active && (!this.expiresAt || this.expiresAt > Date.now());
    };
    return EnvironmentAPIKeyModel;
}());
exports.EnvironmentAPIKeyModel = EnvironmentAPIKeyModel;
var EnvironmentModel = /** @class */ (function () {
    function EnvironmentModel(id, apiKey, project) {
        this.featureStates = [];
        this.identityOverrides = [];
        this.id = id;
        this.apiKey = apiKey;
        this.project = project;
    }
    return EnvironmentModel;
}());
exports.EnvironmentModel = EnvironmentModel;
